export default __webpack_public_path__ + "static/media/(35)-min.cdf83789.jpg";